/**
 * Reducer Manager for dynamic reducer injection
 * Allows lazy loading of Redux reducers
 */

import { combineReducers } from "redux";

class ReducerManager {
  constructor(initialReducers) {
    this.reducers = { ...initialReducers };
    this.store = null;
  }

  setStore(store) {
    this.store = store;
  }

  /**
   * Add a new reducer dynamically
   * @param {string} key - The key for the reducer in the state tree
   * @param {Function} reducer - The reducer function
   */
  add(key, reducer) {
    if (!key || this.reducers[key]) {
      return;
    }

    this.reducers[key] = reducer;
    
    if (this.store) {
      this.store.replaceReducer(
        this.getRootReducer()
      );
    }
  }

  /**
   * Remove a reducer dynamically
   * @param {string} key - The key of the reducer to remove
   */
  remove(key) {
    if (!key || !this.reducers[key]) {
      return;
    }

    delete this.reducers[key];
    
    if (this.store) {
      this.store.replaceReducer(
        this.getRootReducer()
      );
    }
  }

  /**
   * Get the combined root reducer
   */
  getRootReducer() {
    return combineReducers(this.reducers);
  }

  /**
   * Check if a reducer is already registered
   * @param {string} key - The key to check
   */
  has(key) {
    return !!this.reducers[key];
  }
}

export default ReducerManager;
